import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../utilities/fetch";
import { TRoleRecord } from "./modal";
import { useToast } from "../../context/toastProvider";

const schema = yup.object({
    name: yup.string().required("Role Name is required*"),
    description: yup.string().nullable()
});

interface Iprops {
    data: TRoleRecord,
    open: boolean,
    hideDialog: () => void,
    reload: () => void,
}
export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const { control, handleSubmit, formState: { errors }, reset } = useForm<TRoleRecord>({
        resolver: yupResolver(schema),
        defaultValues: props.data
    });

    useEffect(() => {
        reset(props.data);
    }, [props.data])

    const saveToDB = async (body: TRoleRecord) => {
        if (loading) return;
        setLoading(true);

        const id = props.data.id;
        const method = id ? "PUT" : "POST";
        const message = id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(id ? `roles/${id}` : 'roles', {
            method, body,
            onError: (m) => showToast({ severity: 'error', detail: m })
        });

        if (response) {
            props.hideDialog();
            props.reload();
            showToast({ severity: 'success', detail: message });
        }

        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
    }

    function onSubmit(data: TRoleRecord) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Role" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required label="Role Name" control={control} name="name" error={errors.name?.message} />
                <JVInput label="Description" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>

            </form>
        </Dialog>
    );
}
